import { render, staticRenderFns } from "./PuzzleForm.vue?vue&type=template&id=0b85e6d7&scoped=true"
import script from "./PuzzleForm.vue?vue&type=script&lang=js"
export * from "./PuzzleForm.vue?vue&type=script&lang=js"
import style0 from "./PuzzleForm.vue?vue&type=style&index=0&id=0b85e6d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b85e6d7",
  null
  
)

export default component.exports